import { render, staticRenderFns } from "./ForbiddenGoodsTable.vue?vue&type=template&id=26b6b9e9&scoped=true"
import script from "./ForbiddenGoodsTable.vue?vue&type=script&lang=js"
export * from "./ForbiddenGoodsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b6b9e9",
  null
  
)

export default component.exports